import Api from '@/services/Index';

const getCourse = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/course/agreement/student-form');
}
const courseList = async (params) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/wdc/course-list', { params });
}
const startApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/course/agreement/start-application',data,{
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
const storeCourseAgreement = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/course/agreement/store-course',data);
}
const deleteSelectedCourse = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/course/agreement/delete-course/${id}`);
}

const approvedApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`course/agreement/send-approve`)
};

const addNISlot = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("course/agreement/add-non-include-slot")
};

const downloadForm = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/agreement/download-form`, { responseType: 'arraybuffer' });
};

const downloadForAdmin = async (studentProgramId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/agreement/download-form/${studentProgramId}`, { responseType: 'arraybuffer' });
};


export default {
    getCourse,
    courseList,
    startApplication,
    storeCourseAgreement,
    deleteSelectedCourse,
    approvedApplication,
    addNISlot,
    downloadForm,
    downloadForAdmin
}
